<script>
  import { format } from 'svelte-i18n';
  import {
    Dropdown,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    Input,
    InputGroup,
    Tooltip
  } from '@sveltestrap/sveltestrap';

  import { Icon } from '@client/components/icon';

  import { fontBase, fontHeadings, fontsUrl } from '@client/stores/brand';
  import { popular } from '@client/stores/fonts';

  import { generateUUID } from '@common/utils/strings';

  export let size = 'sm';
  export let value;
  export let onChange = () => {};

  const id = `font-dropdown-${generateUUID()}`;

  $: onChange(value);

  $: brandFonts = [...new Set([$fontBase, $fontHeadings])].filter(Boolean);
  $: popularFonts = brandFonts.length ? popular.filter((font) => !brandFonts.includes(font)) : popular;
</script>

<svelte:head>
  {#if $fontsUrl}<link rel="stylesheet" href={$fontsUrl} />{/if}
</svelte:head>

<Dropdown autoClose>
  <InputGroup>
    <Input {...$$restProps} {value} bsSize={size} on:input={(e) => onChange(e.target.value)} />
    <DropdownToggle {id} {size} class="px-2 py-1">
      <Icon name="droplet" />
    </DropdownToggle>
    <Tooltip target={id} placement="bottom">{$format('label.BRAND_FONTS')}</Tooltip>
  </InputGroup>
  <DropdownMenu end>
    {#each brandFonts as font}
      <DropdownItem class="py-2 px-3" active={font === value} on:click={() => (value = font)}>
        <small style:font-family={font}>
          {font}
        </small>
      </DropdownItem>
    {/each}
    {#if brandFonts.length}
      <DropdownItem divider />
    {/if}
    {#each popularFonts as font}
      <DropdownItem class="py-2 px-3" active={font === value} on:click={() => (value = font)}>
        <small style:font-family={font}>
          {font}
        </small>
      </DropdownItem>
    {/each}
  </DropdownMenu>
</Dropdown>
